// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ioFa","location":"Header_location__3tBs0"};